'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SnakeLoader = require('../SnakeLoader');

var _SnakeLoader2 = _interopRequireDefault(_SnakeLoader);

var _reactHoc = require('@mindz/react-hoc');

var _ButtonDefaultModule = require('./Button.default.module.css');

var _ButtonDefaultModule2 = _interopRequireDefault(_ButtonDefaultModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ButtonDefault = function (_Component) {
  _inherits(ButtonDefault, _Component);

  function ButtonDefault() {
    _classCallCheck(this, ButtonDefault);

    return _possibleConstructorReturn(this, (ButtonDefault.__proto__ || Object.getPrototypeOf(ButtonDefault)).apply(this, arguments));
  }

  _createClass(ButtonDefault, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          type = _props.type,
          id = _props.id,
          theme = _props.theme,
          Icon = _props.icon,
          isIconRight = _props.isIconRight,
          children = _props.children,
          size = _props.size,
          disabled = _props.disabled,
          onClick = _props.onClick,
          url = _props.url,
          isLoading = _props.isLoading,
          className = _props.className,
          loadingIcon = _props.loadingIcon,
          isCircle = _props.isCircle;

      if (url) {
        return _react2.default.createElement(_reactRouterDom.Link, {
          to: url,
          className: cx('root', _defineProperty({}, className, !!className), theme, size, {
            url: url
          }, {
            Icon: Icon
          }, {
            isCircle: isCircle
          }, {
            disabled: isLoading || disabled
          }, {
            isLoading: isLoading
          })
        }, isLoading && _react2.default.createElement(_SnakeLoader2.default, {
          type: 'bright',
          customLoadingIcon: loadingIcon,
          size: size
        }), Icon && _react2.default.createElement(Icon, null), _react2.default.createElement('span', null, children));
      }

      return _react2.default.createElement('button', {
        type: type,
        id: id,
        disabled: isLoading || disabled,
        onClick: onClick,
        className: cx('root', _defineProperty({}, className, !!className), theme, size, {
          url: url
        }, {
          Icon: Icon
        }, {
          isIconRight: isIconRight
        }, {
          isCircle: isCircle
        }, {
          disabled: isLoading || disabled
        }, {
          isLoading: isLoading
        })
      }, isLoading && _react2.default.createElement(_SnakeLoader2.default, {
        type: 'bright',
        customLoadingIcon: loadingIcon,
        size: size
      }), !isIconRight && Icon && _react2.default.createElement(Icon, null), _react2.default.createElement('span', null, children), isIconRight && Icon && _react2.default.createElement(Icon, null));
    }
  }]);

  return ButtonDefault;
}(_react.Component);

ButtonDefault.propTypes = {
  url: _propTypes2.default.string
};
ButtonDefault.defaultProps = {
  disabled: false,
  onClick: function onClick() {}
};
exports.default = (0, _reactHoc.withStyles)(_ButtonDefaultModule2.default)(ButtonDefault);
module.exports = exports.default;